// Analytics 配置文件 - 从 site.ts 导入统一配置
import { siteConfig } from './site';

// 导出统一配置，保持向后兼容
export const ANALYTICS_CONFIG = siteConfig.analytics;
export const AD_SLOTS = siteConfig.adSlots;

// 事件跟踪函数
export const trackEvent = (eventName: string, parameters?: Record<string, any>) => {
  if (typeof window !== 'undefined' && window.gtag && ANALYTICS_CONFIG.googleAnalytics.enabled) {
    window.gtag('event', eventName, {
      ...parameters,
      timestamp: new Date().toISOString(),
    });
  }
};

// 页面浏览跟踪
export const trackPageView = (pagePath: string, pageTitle?: string) => {
  if (typeof window !== 'undefined' && window.gtag && ANALYTICS_CONFIG.googleAnalytics.enabled) {
    window.gtag('config', ANALYTICS_CONFIG.googleAnalytics.measurementId, {
      page_path: pagePath,
      page_title: pageTitle || document.title,
    });
  }
};

// 转化跟踪
export const trackConversion = (conversionId: string, value?: number, currency = 'USD') => {
  if (typeof window !== 'undefined' && window.gtag && ANALYTICS_CONFIG.googleAnalytics.enabled) {
    window.gtag('event', 'conversion', {
      send_to: conversionId,
      value: value,
      currency: currency,
    });
  }
};